"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _axios = _interopRequireDefault(require("axios"));
var _lodash = require("lodash");
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
require("../../common/style.scss");
var _formatVodData2 = require("../../utils/formatVodData");
var _sessionStorage = _interopRequireDefault(require("../../utils/sessionStorage"));
var _mockData = require("./mockData");
var _reportUtil = require("../../utils/reportUtil");
var _yunApi = require("../../utils/yunApi");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  MixDiscountPurchaseCard = _require.MixDiscountPurchaseCard;
// timeUnit 年1/月2/日3/时4/分5/秒6/一次性购买7
const TIME_UNIT = {
  1: 'year',
  2: 'month',
  3: 'day',
  4: 'hour',
  5: 'minute',
  6: 'second',
  7: 'One time purchase'
};

// 跳转去购买付款的页面
const GO_TO_BUY_ORDER_URL = 'https://buy.tencentcloud.com/intlPrepay/pay?BigOrderIds=';
const LIGHTHOUSE_MOUDLE_CODE = 'lighthouse';
const isMockData = false;
function getToBuyHref(bigOrderId, options = {}) {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString;
  const href = `${GO_TO_BUY_ORDER_URL}${bigOrderId}`;
  return formatUrlString(href);
}
const formatDiscountPurchaseCard = (properties, options = {}) => {
  const modTitle = properties.modTitle,
    _properties$headConfi = properties.headConfig,
    headConfig = _properties$headConfi === void 0 ? {} : _properties$headConfi,
    pcColor = properties.pcColor,
    backgroundImage = properties.backgroundImage,
    _properties$configura = properties.configuration,
    configuration = _properties$configura === void 0 ? [] : _properties$configura,
    _properties$modelConf = properties.modelConfig,
    modelConfig = _properties$modelConf === void 0 ? {} : _properties$modelConf,
    _properties$timeConfi = properties.timeConfig,
    timeConfig = _properties$timeConfi === void 0 ? {} : _properties$timeConfi,
    _properties$porintId = properties.porintId,
    porintId = _properties$porintId === void 0 ? '' : _properties$porintId,
    _properties$colorThem = properties.colorTheme,
    colorTheme = _properties$colorThem === void 0 ? '' : _properties$colorThem,
    sdkAppIdLabel = properties.sdkAppIdLabel,
    sdkAppIdText = properties.sdkAppIdText;
  const _getFormatUrlMethods2 = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods2.formatUrlString,
    formatUrlInText = _getFormatUrlMethods2.formatUrlInText;
  const _ref = (options === null || options === void 0 ? void 0 : options.filterOptions) || {},
    classifyName = _ref.classifyName,
    _ref$layoutMode = _ref.layoutMode,
    layoutMode = _ref$layoutMode === void 0 ? false : _ref$layoutMode;
  modelConfig.isQueryPrice = false;
  const description = headConfig.description,
    _headConfig$list = headConfig.list,
    list = _headConfig$list === void 0 ? [] : _headConfig$list;
  const ruleList = list.map((ruleItem, index) => {
    const txt = ruleItem.txt,
      type = ruleItem.type,
      hrefBase = ruleItem.href,
      modalTitle = ruleItem.modalTitle,
      richTextContent = ruleItem.richTextContent,
      popConfirm = ruleItem.popConfirm,
      popConfirmHrefBase = ruleItem.popConfirmHref,
      popCancel = ruleItem.popCancel,
      popCancelHrefBase = ruleItem.popCancelHref;
    const href = formatUrlString(hrefBase);
    const popConfirmHref = formatUrlString(popConfirmHrefBase);
    const popCancelHref = formatUrlString(popCancelHrefBase);
    const richBtnTxt = [];
    popCancel && richBtnTxt.push({
      type: 'cancel',
      txt: popCancel,
      href: popCancelHref
    });
    popConfirm && richBtnTxt.push({
      type: 'confirm',
      txt: popConfirm,
      href: popConfirmHref
    });
    return {
      txt,
      type,
      href,
      modalTitle,
      richTextContent: formatUrlInText(richTextContent),
      richBtnTxt,
      extendProps: {
        'report-event-goal': 'click_discountPurchaseCard_card',
        'report-event': 'click_buy_discount_card_top_href',
        'report-ext1': index,
        'report-ext2': txt,
        'report-ext3': href
      }
    };
  });
  let resultList = configuration.map((productItem, index) => {
    const _productItem$classify = productItem.classifyName,
      classifyName = _productItem$classify === void 0 ? '' : _productItem$classify,
      _productItem$title = productItem.title,
      title = _productItem$title === void 0 ? '' : _productItem$title,
      _productItem$modelTit = productItem.modelTitle,
      modelTitle = _productItem$modelTit === void 0 ? '' : _productItem$modelTit,
      _productItem$desc = productItem.desc,
      desc = _productItem$desc === void 0 ? '' : _productItem$desc,
      _productItem$timeText = productItem.timeText,
      timeText = _productItem$timeText === void 0 ? '' : _productItem$timeText,
      _productItem$btnTxt = productItem.btnTxt,
      btnTxt = _productItem$btnTxt === void 0 ? '' : _productItem$btnTxt,
      _productItem$timeShow = productItem.timeShow,
      timeShow = _productItem$timeShow === void 0 ? '' : _productItem$timeShow,
      _productItem$resouseT = productItem.resouseText,
      resouseText = _productItem$resouseT === void 0 ? '' : _productItem$resouseT,
      _productItem$resouseL = productItem.resouseListShow,
      resouseListShow = _productItem$resouseL === void 0 ? [] : _productItem$resouseL,
      _productItem$btnHref = productItem.btnHref,
      btnHrefBase = _productItem$btnHref === void 0 ? '' : _productItem$btnHref,
      _productItem$textList = productItem.textList,
      textList = _productItem$textList === void 0 ? [] : _productItem$textList,
      description = productItem.description,
      freeTitle = productItem.freeTitle,
      _productItem$commodit = productItem.commodityObject,
      commodityObject = _productItem$commodit === void 0 ? '{}' : _productItem$commodit,
      _productItem$isNoDisc = productItem.isNoDiscount,
      isNoDiscount = _productItem$isNoDisc === void 0 ? false : _productItem$isNoDisc,
      _productItem$hasSdkAp = productItem.hasSdkAppId,
      hasSdkAppId = _productItem$hasSdkAp === void 0 ? false : _productItem$hasSdkAp;
    const btnHref = formatUrlString(btnHrefBase);
    let isConnect = false;
    let hasNoModel = false;
    let eventId = '';
    let ecId = '';
    let eventType = '';
    if (commodityObject) {
      const obj = JSON.parse(commodityObject);
      isConnect = obj.isConnect || false;
      hasNoModel = obj.hasNoModel || false;
      eventId = obj.event || '';
      eventType = obj.eventType || '';
      ecId = obj.commodity || '';
    }
    return {
      classifyName,
      title,
      desc: formatUrlInText(desc),
      cardDiscount: isNoDiscount ? freeTitle : 0,
      cardOriginal: 0,
      timeText,
      timeShow,
      resouseText,
      resouseListShow,
      btnTxt,
      href: btnHref,
      textList,
      description,
      freeTitle,
      isConnect,
      hasNoModel,
      hasSdkAppId,
      eventId,
      eventType,
      ecId,
      isNoDiscount,
      modelTitle,
      cardDefaultSelect: {
        timeUnit: 0,
        timeSpan: 0,
        regionId: 0,
        blueprintId: '',
        purchaseNum: 1
      },
      timeInfoList: [{
        timeSpan: 0,
        timeUnit: 0,
        timeText: ''
      }],
      regionInfoList: [{
        regionId: 0,
        regionName: ''
      }],
      bluePrintList: [{
        blueprintId: '',
        osName: '',
        displayTitle: '',
        displayVersion: ''
      }],
      skuList: {
        sku_0_0_0: ''
      },
      limitNum: 1,
      minPurchaseNum: 1,
      platformType: '',
      isQueryPrice: isNoDiscount ? false : true,
      isCreateOrder: false,
      queryPriceText: modelConfig.queryPriceText || 'Inquiry in progress',
      createOrderText: modelConfig.createOrderText || 'Purchasing...',
      extendProps: {
        'report-event-goal': 'click_buy_discount_card',
        'report-event': 'click_buy_discount_card_button',
        'report-ext1': index,
        'report-ext2': eventId,
        'report-ext3': ecId
      },
      extendModelBtnProps: {
        'report-event-goal': 'click_discountPurchaseCard_card_model_button',
        'report-event': 'click_buy_discount_card_model_button',
        'report-ext1': index,
        'report-ext2': eventId,
        'report-ext3': ecId
      }
    };
  });
  // filterTypeList过滤条件
  if (classifyName) {
    resultList = resultList.filter((o, index) => o.classifyName.split(',').includes(classifyName));
  }
  return {
    modTitle,
    pcColor,
    backgroundImage,
    headConfig: {
      description,
      list: ruleList
    },
    configuration: resultList,
    modelConfig,
    timeConfig,
    porintId,
    colorTheme,
    layoutMode,
    sdkAppIdLabel,
    sdkAppIdText
  };
};

// 处理gems配置的数据和远程接口拉取的数据合并解析处理
const doMergeDiscountData = (gemsData, remoteData, timeConfig, sdkAppIdLabel) => {
  if (remoteData && remoteData.length > 0) {
    const result = gemsData.map((gemsDataItem, index) => {
      if (gemsDataItem.isNoDiscount) {
        return _objectSpread(_objectSpread({}, gemsDataItem), {}, {
          cardDiscount: gemsDataItem.freeTitle,
          isQueryPrice: false,
          sdkAppText: sdkAppIdLabel
        });
      }
      const remoteItem = (remoteData || []).filter(item => gemsDataItem.eventId === item.eventId && gemsDataItem.ecId === item.ecId);
      if (remoteItem.length === 0) {
        return {
          cardDiscount: -1 // 置为-1方便后面filter过滤
        };
      }
      const _ref2 = remoteItem[0] || {},
        discountInfo = _ref2.discountInfo;
      const _discountInfo$timeInf = discountInfo.timeInfoList,
        timeInfoList = _discountInfo$timeInf === void 0 ? [] : _discountInfo$timeInf,
        _discountInfo$regionI = discountInfo.regionInfoList,
        regionInfoList = _discountInfo$regionI === void 0 ? [] : _discountInfo$regionI,
        _discountInfo$bluePri = discountInfo.bluePrintList,
        bluePrintList = _discountInfo$bluePri === void 0 ? [] : _discountInfo$bluePri,
        _discountInfo$defPric = discountInfo.defPrice,
        defPrice = _discountInfo$defPric === void 0 ? -1 : _discountInfo$defPric,
        _discountInfo$defOrig = discountInfo.defOriginPrice,
        defOriginPrice = _discountInfo$defOrig === void 0 ? -1 : _discountInfo$defOrig,
        _discountInfo$skuInfo = discountInfo.skuInfoList,
        skuInfoList = _discountInfo$skuInfo === void 0 ? [] : _discountInfo$skuInfo,
        _discountInfo$maxPurc = discountInfo.maxPurchaseNum,
        maxPurchaseNum = _discountInfo$maxPurc === void 0 ? 1 : _discountInfo$maxPurc,
        _discountInfo$minPurc = discountInfo.minPurchaseNum,
        minPurchaseNum = _discountInfo$minPurc === void 0 ? 1 : _discountInfo$minPurc,
        _discountInfo$platfor = discountInfo.platformType,
        platformType = _discountInfo$platfor === void 0 ? '' : _discountInfo$platfor,
        _discountInfo$moduleC = discountInfo.moduleCode,
        moduleCode = _discountInfo$moduleC === void 0 ? '' : _discountInfo$moduleC;
      let _discountInfo$spuInfo = discountInfo.spuInfo,
        spuInfo = _discountInfo$spuInfo === void 0 ? '' : _discountInfo$spuInfo;
      const _doRemoteDataEvent = doRemoteDataEvent(timeInfoList, regionInfoList, bluePrintList, skuInfoList, timeConfig, moduleCode),
        timeInfoListDefault = _doRemoteDataEvent.timeInfoListDefault,
        regionInfoListDefault = _doRemoteDataEvent.regionInfoListDefault,
        bluePrintListDefault = _doRemoteDataEvent.bluePrintListDefault,
        skuListDefault = _doRemoteDataEvent.skuListDefault,
        cardDefaultSelectDefault = _doRemoteDataEvent.cardDefaultSelectDefault;
      const discount = (defPrice / 100).toFixed(2);
      const original = (defOriginPrice / 100).toFixed(2);
      const gemsItem = JSON.parse(JSON.stringify(gemsDataItem));
      if (spuInfo) {
        spuInfo = JSON.parse(spuInfo);
      } else {
        spuInfo = {};
      }
      return _objectSpread(_objectSpread({}, gemsItem), {}, {
        timeInfoList: timeInfoListDefault,
        regionInfoList: regionInfoListDefault,
        bluePrintList: bluePrintListDefault,
        skuList: skuListDefault,
        limitNum: maxPurchaseNum === -1 ? 999999 : maxPurchaseNum,
        minPurchaseNum: minPurchaseNum === -1 ? 1 : minPurchaseNum,
        cardDiscount: discount,
        cardOriginal: original,
        cardDefaultSelect: cardDefaultSelectDefault,
        platformType,
        isQueryPrice: false,
        moduleCode,
        spuInfo,
        sdkAppText: sdkAppIdLabel
      });
    }).filter(item => String(item.cardDiscount) !== '-1');
    return result;
  }
  return [];
};

// 查询sdkAppInfo
const doQuerySdkAppInfos = (setSdkAppInfos, sdkAppIdLabel) => {
  if (isMockData || !sdkAppIdLabel) {
    return;
  }
  (0, _yunApi.getApplicatList)(({
    code,
    data
  }) => {
    if (code === 0) {
      const _data$Response$SdkApp = data.Response.SdkAppInfos,
        SdkAppInfos = _data$Response$SdkApp === void 0 ? [] : _data$Response$SdkApp;
      if (SdkAppInfos.length) {
        setSdkAppInfos(SdkAppInfos);
      } else {
        // 未拉去到应用列表，提示
        window.asyncNoSdkAppInfoDialog();
      }
    }
  });
};

// 请求远端数据
const doQueryDiscountData = (configuration, setPSData, timeConfig, sdkAppIdLabel) => {
  const ecReqList = configuration.filter(item => !item.isNoDiscount).filter(item => item.eventId && item.ecId).map(item => {
    const eventId = item.eventId,
      ecId = item.ecId;
    return {
      eventId,
      ecId
    };
  });
  if (ecReqList.length === 0) {
    setPSData(configuration);
    return;
  }
  const params = {
    ecReqList
  };
  if (isMockData) {
    const code = _mockData.mockData.code,
      _mockData$data = _mockData.mockData.data,
      list = _mockData$data === void 0 ? [] : _mockData$data;
    if (code === 0) {
      const resultData = doMergeDiscountData(configuration, list, timeConfig, sdkAppIdLabel);
      setPSData(resultData);
    }
    return;
  }
  (0, _axios.default)({
    method: 'post',
    url: '/render/api/configsolution/queryDiscountProductList',
    data: params
  }).then(({
    data
  }) => {
    const code = data.code,
      _data$data = data.data,
      list = _data$data === void 0 ? [] : _data$data;
    if (code === 0) {
      const resultData = doMergeDiscountData(configuration, list, timeConfig, sdkAppIdLabel);
      setPSData(resultData);
    }
  }).catch(() => {
    setPSData(configuration);
  });
};

// 拉取的远端数据处理
const doRemoteDataEvent = (timeInfo, regionInfo, bluePrintInfo, skuInfo, timeConfig, moduleCode) => {
  let timeInfoList = [{
    timeSpan: 0,
    timeUnit: 0,
    timeText: ''
  }];
  let regionInfoList = [{
    regionId: 0,
    regionName: ''
  }];
  let bluePrintList = [{
    blueprintId: '',
    osName: '',
    displayTitle: '',
    displayVersion: ''
  }];
  let skuList = {
    sku_0_0_0: ''
  };
  if (timeInfo.length > 0) {
    timeInfoList = timeInfo.map(item => {
      let info = '';
      if (item.timeUnit === 1) {
        info = `${item.timeSpan} ${item.timeSpan > 1 ? timeConfig.years || 'years' : timeConfig.year || 'year'}`;
      } else if (item.timeUnit === 2) {
        info = `${item.timeSpan} ${item.timeSpan > 1 ? timeConfig.months || 'months' : timeConfig.month || 'month'}`;
      } else {
        info = `${item.timeSpan} ${TIME_UNIT[item.timeUnit]}`;
      }
      return _objectSpread(_objectSpread({}, item), {}, {
        timeText: info
      });
    });
  }
  if (bluePrintInfo.length > 0) {
    bluePrintList = bluePrintInfo;
  }
  if (regionInfo.length > 0) {
    regionInfoList = regionInfo.map(item => {
      return _objectSpread(_objectSpread({}, item), {}, {
        regionName: item.regionEnName
      });
    });
  }
  if (skuInfo.length > 0) {
    if (!moduleCode || LIGHTHOUSE_MOUDLE_CODE === moduleCode.toLocaleLowerCase()) {
      const skuListTemp = {};
      //  格式 `sku_${regionId}_${timeUnit}_${timeSpan}`
      skuInfo.forEach(element => {
        skuListTemp[`sku_${element.regionId}_${element.timeUnit}_${element.timeSpan}`] = element.skuId;
      });
      skuList = skuListTemp;
    } else {
      skuList = skuInfo;
    }
  }
  const cardDefaultSelect = {
    timeUnit: timeInfoList[0] && timeInfoList[0].timeUnit || 0,
    timeSpan: timeInfoList[0] && timeInfoList[0].timeSpan || 0,
    regionId: regionInfoList[0] && regionInfoList[0].regionId || 0,
    blueprintId: bluePrintList[0] && bluePrintList[0].blueprintId || '',
    purchaseNum: 1
  };
  return {
    timeInfoListDefault: timeInfoList,
    regionInfoListDefault: regionInfoList,
    bluePrintListDefault: bluePrintList,
    skuListDefault: skuList,
    cardDefaultSelectDefault: cardDefaultSelect
  };
};

// useEffect监听数组的变化的变量处理方法
const useCampare = (value, compare) => {
  const ref = React.useRef([]);
  if (!compare(value, ref.current)) {
    ref.current = [].concat(value);
  }
  return ref.current;
};
_axios.default.defaults.withCredentials = true;
_axios.default.defaults.crossDomain = true;
_axios.default.defaults.headers.post['Content-Type'] = 'application/json';
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos,
  /*
   * 筛选+分页 容器传过来的参数 { }
   * filterTypeList: [0,1,2] 容器过滤之后的列表的索引
   * pageIndex
   * pageSize
   * */
  filterOptions
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatDiscountPurcha = formatDiscountPurchaseCard(data, {
        domains,
        filterOptions
      }),
      modTitle = _formatDiscountPurcha.modTitle,
      headConfig = _formatDiscountPurcha.headConfig,
      _formatDiscountPurcha2 = _formatDiscountPurcha.configuration,
      configuration = _formatDiscountPurcha2 === void 0 ? [] : _formatDiscountPurcha2,
      pcColor = _formatDiscountPurcha.pcColor,
      backgroundImage = _formatDiscountPurcha.backgroundImage,
      _formatDiscountPurcha3 = _formatDiscountPurcha.modelConfig,
      modelConfig = _formatDiscountPurcha3 === void 0 ? {} : _formatDiscountPurcha3,
      _formatDiscountPurcha4 = _formatDiscountPurcha.timeConfig,
      timeConfig = _formatDiscountPurcha4 === void 0 ? {} : _formatDiscountPurcha4,
      porintId = _formatDiscountPurcha.porintId,
      colorTheme = _formatDiscountPurcha.colorTheme,
      layoutMode = _formatDiscountPurcha.layoutMode,
      sdkAppIdLabel = _formatDiscountPurcha.sdkAppIdLabel,
      sdkAppIdText = _formatDiscountPurcha.sdkAppIdText;
    const listArr = useCampare(configuration, _lodash.isEqual);
    const _React$useState = React.useState([]),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      psData = _React$useState2[0],
      setPSData = _React$useState2[1];
    const _React$useState3 = React.useState({}),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      updateCard = _React$useState4[0],
      setUpdateCard = _React$useState4[1];
    const _React$useState5 = React.useState({}),
      _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
      updateSdkAppInfo = _React$useState6[0],
      setUpdateSdkAppInfo = _React$useState6[1];
    const _React$useState7 = React.useState([{
        Name: sdkAppIdText,
        ID: 0
      }]),
      _React$useState8 = (0, _slicedToArray2.default)(_React$useState7, 2),
      sdkAppInfos = _React$useState8[0],
      setSdkAppInfos = _React$useState8[1];
    const _React$useState9 = React.useState(modelConfig),
      _React$useState0 = (0, _slicedToArray2.default)(_React$useState9, 2),
      modelText = _React$useState0[0],
      setModelText = _React$useState0[1];
    const bgStyle = pcColor ? (0, _componentUtils.doComponentsBgColorEvent)(pcColor) : {}; // 处理组件背景色
    const _formatVodData = (0, _formatVodData2.formatVodData)(backgroundImage),
      url = _formatVodData.url;
    if (url) {
      bgStyle['backgroundImage'] = `url(${url})`;
    }
    React.useEffect(() => {
      const hostname = window.location.hostname;
      // 编辑器中不去请求拉取价格的接口
      if (hostname.endsWith('.woa.com') && !isMockData) {
        setPSData(configuration);
        return;
      }
      doQuerySdkAppInfos(setSdkAppInfos, sdkAppIdLabel);
      doQueryDiscountData(configuration, setPSData, timeConfig, sdkAppIdLabel);
    }, [listArr]);
    React.useEffect(() => {
      // 取session数据
      const lhFormLogin = _sessionStorage.default.get('lh');
      // session有数据就查询登录态
      if (lhFormLogin) {
        // 判断登录态(防止在登录页面未登录back回页面，再次强制跳转到登录页)
        (0, _axios.default)({
          method: 'get',
          url: '/render/api/configsolution/getUserInfo'
        }).then(({
          data
        }) => {
          var _data$data2;
          // 已登录回来的
          if ((data === null || data === void 0 ? void 0 : data.code) === 0 && (_data$data2 = data.data) !== null && _data$data2 !== void 0 && _data$data2.uin) {
            _sessionStorage.default.remove('lh');
            handlerOrder(JSON.parse(lhFormLogin), () => {
              console.log('from login...');
            }, {
              domains
            });
          }
        });
      }
      return () => _sessionStorage.default.remove('lh');
    }, []);

    // 卡片购买数量变化
    const handleCardNumChange = updateData => {
      const cardItemIndex = updateData.cardItemIndex;
      setUpdateCard({
        cardItemIndex,
        isQueryPrice: true
      });
      (0, _axios.default)({
        method: 'post',
        url: '/render/api/configsolution/queryEventCommodityPrice',
        data: updateData
      }).then(({
        data
      }) => {
        const _data$data3 = data.data,
          result = _data$data3 === void 0 ? {} : _data$data3;
        setUpdateCard({
          cardItemIndex,
          cardDiscount: (result.price / 100).toFixed(2),
          cardOriginal: (result.originPrice / 100).toFixed(2),
          isQueryPrice: false
        });
      });
    };
    // 卡片时长选择变化的回调
    const handleChangeCard = updateData => {
      const cardItemIndex = updateData.cardItemIndex,
        _updateData$isChooseS = updateData.isChooseSame,
        isChooseSame = _updateData$isChooseS === void 0 ? false : _updateData$isChooseS;
      if (isChooseSame) {
        // 选择相同的就不走请求流程
        return;
      }
      const params = _objectSpread(_objectSpread({}, updateData), {}, {
        purchaseNum: 1
      });
      setUpdateCard({
        cardItemIndex,
        isQueryPrice: true
      });
      (0, _axios.default)({
        method: 'post',
        url: '/render/api/configsolution/queryEventCommodityPrice',
        data: params
      }).then(({
        data
      }) => {
        const _data$data4 = data.data,
          result = _data$data4 === void 0 ? {} : _data$data4;
        setUpdateCard({
          cardItemIndex,
          cardDiscount: (result.price / 100).toFixed(2),
          cardOriginal: (result.originPrice / 100).toFixed(2),
          isQueryPrice: false
        });
      });
    };
    // 卡片资源选择变化的回调
    const handleResouseChangeCard = updateData => {
      const cardItemIndex = updateData.cardItemIndex,
        _updateData$isChooseS2 = updateData.isChooseSame,
        isChooseSame = _updateData$isChooseS2 === void 0 ? false : _updateData$isChooseS2;
      if (isChooseSame) {
        // 选择相同的就不走请求流程
        return;
      }
      const params = _objectSpread({}, updateData);
      setUpdateCard({
        cardItemIndex,
        isQueryPrice: true
      });
      (0, _axios.default)({
        method: 'post',
        url: '/render/api/configsolution/queryEventCommodityPrice',
        data: params
      }).then(({
        data
      }) => {
        const _data$data5 = data.data,
          result = _data$data5 === void 0 ? {} : _data$data5;
        setUpdateCard({
          cardItemIndex,
          cardDiscount: (result.price / 100).toFixed(2),
          cardOriginal: (result.originPrice / 100).toFixed(2),
          isQueryPrice: false
        });
      });
    };
    // 购买弹窗变化时查询价格
    const handleSetPrice = (priceParams, type) => {
      setModelText(_objectSpread(_objectSpread({}, modelText), {}, {
        isQueryPrice: true,
        queryPriceText: modelConfig.queryPriceText || 'Inquiry in progress'
      }));
      if (type === 'area') {
        (0, _axios.default)({
          method: 'post',
          url: '/render/api/configsolution/queryBluePrints',
          data: {
            regionId: priceParams.regionId,
            platformType: priceParams.platformType
          }
        }).then(({
          data
        }) => {
          var _bluePrintList$;
          const _data$data6 = data.data,
            result = _data$data6 === void 0 ? {} : _data$data6;
          const _ref3 = result || {},
            _ref3$bluePrintList = _ref3.bluePrintList,
            bluePrintList = _ref3$bluePrintList === void 0 ? [] : _ref3$bluePrintList;
          const blueprintId = ((_bluePrintList$ = bluePrintList[0]) === null || _bluePrintList$ === void 0 ? void 0 : _bluePrintList$.blueprintId) || '';
          priceParams.bluePrintId = blueprintId;
          (0, _axios.default)({
            method: 'post',
            url: '/render/api/configsolution/queryEventCommodityPrice',
            data: priceParams
          }).then(({
            data
          }) => {
            const _data$data7 = data.data,
              result = _data$data7 === void 0 ? {} : _data$data7;
            const modelTextResult = _objectSpread(_objectSpread({}, modelText), {}, {
              blueprintId,
              bluePrintList,
              discount: (result.price / 100).toFixed(2),
              original: (result.originPrice / 100).toFixed(2)
            });
            // 询价失败
            if (data.price === -1) {
              modelTextResult.isQueryPrice = true;
              modelTextResult.queryPriceText = modelConfig.queryPriceFailText || 'Inquiry failed';
            } else {
              modelTextResult.isQueryPrice = false;
              modelTextResult.isBuyWait = false;
            }
            setModelText(modelTextResult);
          });
        });
      } else {
        (0, _axios.default)({
          method: 'post',
          url: '/render/api/configsolution/queryEventCommodityPrice',
          data: priceParams
        }).then(({
          data
        }) => {
          const _data$data8 = data.data,
            result = _data$data8 === void 0 ? {} : _data$data8;
          const modelTextResult = _objectSpread(_objectSpread({}, modelText), {}, {
            discount: (result.price / 100).toFixed(2),
            original: (result.originPrice / 100).toFixed(2)
          });
          if (type === 'image') {
            modelTextResult.blueprintId = priceParams.bluePrintId;
          }
          // 询价失败
          if (data.price === -1) {
            modelTextResult.isQueryPrice = true;
            modelTextResult.queryPriceText = modelConfig.queryPriceFailText || 'Inquiry failed';
          } else {
            modelTextResult.isQueryPrice = false;
            modelTextResult.isBuyWait = false;
          }
          setModelText(modelTextResult);
        });
      }
    };
    // 点击弹窗购买
    const handlerOrder = (orderInfoParams, closeCallback, options = {}) => {
      if (orderInfoParams.orderInfo.price) {
        orderInfoParams.orderInfo.price = Number((orderInfoParams.orderInfo.price * 100).toFixed(0));
      }
      (0, _axios.default)({
        method: 'post',
        url: '/render/api/configsolution/createOrder',
        data: orderInfoParams
      }).then(({
        data
      }) => {
        const _data$data9 = data.data,
          result = _data$data9 === void 0 ? {} : _data$data9,
          code = data.code;
        if (code === 0) {
          window.recordBehavior && window.recordBehavior.reportEvent('click_discount_create_order_success');
          window.location.href = getToBuyHref(result.bigOrderId, {
            domains
          });
        } else if (code === -1000) {
          window.recordBehavior && window.recordBehavior.reportEvent('click_discount_create_order_fail_nologin');
          // 未登录存储数据再带特定的参数跳转到登录页
          _sessionStorage.default.set('lh', JSON.stringify(orderInfoParams));
          window.location.href = `${location.origin}/login?s_url=${encodeURIComponent(location.href)}`;
        } else if (code === -1001) {
          const total = result.total;
          if (total) {
            // 账号未开户，账号已绑卡
            window.asyncAccountNoCardDialog();
          } else {
            // 账号未开户，账号未绑卡
            window.asyncRegisterStepDialog();
          }
          window.recordBehavior && window.recordBehavior.reportEvent('click_discount_create_order_fail_noopen_account');
        } else {
          window.recordBehavior && window.recordBehavior.reportEvent('click_discount_create_order_fail', {
            ext1: code || ''
          });
          window.asyncErrorDialog({
            code
          });
        }
        setModelText(_objectSpread(_objectSpread({}, modelText), {}, {
          isBuyWait: false
        }));
        closeCallback();
      });
    };
    // 点击卡片购买
    const handlerCardOrder = (orderInfoParams, cardItemIndex) => {
      if (orderInfoParams.orderInfo.price) {
        orderInfoParams.orderInfo.price = Number((orderInfoParams.orderInfo.price * 100).toFixed(0));
      }
      // 下单时，如果有sdkAppId且值不为有效数字，强提示
      if (orderInfoParams.orderInfo.hasOwnProperty('sdkAppId') && !orderInfoParams.orderInfo.sdkAppId) {
        // 未拉去到应用列表，提示
        window.asyncNoSdkAppInfoDialog();
        return;
      }
      setUpdateCard({
        cardItemIndex,
        isCreateOrder: true
      });
      (0, _axios.default)({
        method: 'post',
        url: '/render/api/configsolution/createOrder',
        data: orderInfoParams
      }).then(({
        data
      }) => {
        const _data$data0 = data.data,
          result = _data$data0 === void 0 ? {} : _data$data0,
          code = data.code;
        if (code === 0) {
          window.recordBehavior && window.recordBehavior.reportEvent('click_discount_card_create_order_success');
          window.location.href = getToBuyHref(result.bigOrderId, {
            domains
          });
        } else if (code === -1000) {
          window.recordBehavior && window.recordBehavior.reportEvent('click_discount_card_create_order_fail_nologin');
          // 未登录存储数据再带特定的参数跳转到登录页
          _sessionStorage.default.set('lh', JSON.stringify(orderInfoParams));
          window.location.href = `${location.origin}/login?s_url=${encodeURIComponent(location.href)}`;
        } else if (code === -1001) {
          const total = result.total;
          if (total) {
            // 账号未开户，账号已绑卡
            window.asyncAccountNoCardDialog();
          } else {
            // 账号未开户，账号未绑卡
            window.asyncRegisterStepDialog();
          }
          window.recordBehavior && window.recordBehavior.reportEvent('click_discount_card_create_order_fail_noopen_account');
        } else {
          window.recordBehavior && window.recordBehavior.reportEvent('click_discount_card_create_order_fail', {
            ext1: code || ''
          });
          window.asyncErrorDialog({
            code
          });
        }
        setTimeout(() => {
          setUpdateCard({
            cardItemIndex,
            isCreateOrder: false
          });
        }, 3000);
      }).catch(() => {
        setUpdateCard({
          cardItemIndex,
          isCreateOrder: false
        });
      });
    };
    // 点击卡片走领取逻辑
    const handlerFreeBuyBtn = (orderInfoParams, cardItemIndex) => {
      setUpdateCard({
        cardItemIndex,
        isCreateOrder: true
      });
      window.asyncReceiveCommodity(orderInfoParams);
      setTimeout(() => {
        setUpdateCard({
          cardItemIndex,
          isCreateOrder: false
        });
      }, 2000);
    };
    // 卡片sdkappid选择变化的回调
    const handleSdkAppChangeCard = sdkChooseInfo => {
      const cardItemIndex = sdkChooseInfo.cardItemIndex,
        _sdkChooseInfo$isChoo = sdkChooseInfo.isChooseSame,
        isChooseSame = _sdkChooseInfo$isChoo === void 0 ? false : _sdkChooseInfo$isChoo,
        sdkAppId = sdkChooseInfo.sdkAppId;
      if (isChooseSame) {
        // 选择相同的就不走请求流程
        return;
      }
      (0, _yunApi.describePlanLicense)(sdkAppId, ({
        code,
        data
      }) => {
        if (code === 0) {
          const _data$Response = data.Response,
            _data$Response$Expire = _data$Response.ExpireTime,
            ExpireTime = _data$Response$Expire === void 0 ? '' : _data$Response$Expire,
            _data$Response$Resour = _data$Response.ResourceId,
            ResourceId = _data$Response$Resour === void 0 ? '' : _data$Response$Resour;
          setUpdateSdkAppInfo({
            cardItemIndex,
            licenseExpireTime: ExpireTime,
            resourceId: ResourceId,
            sdkAppId: sdkChooseInfo.sdkAppId
          });
        }
      });
    };
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId || modTitle
    }, (0, _reportUtil.reportShow)(['show_mixDiscountPurchaseCard', componentKey, modTitle])), /*#__PURE__*/React.createElement(MixDiscountPurchaseCard, {
      style: bgStyle,
      flexTitle: modTitle,
      colorTheme: colorTheme,
      headConfig: headConfig,
      configuration: psData,
      sdkAppInfos: sdkAppInfos,
      updateSdkAppInfo: updateSdkAppInfo,
      updateCard: updateCard,
      modelText: modelText,
      layoutMode: layoutMode,
      onCardChangeTime: data => {
        handleChangeCard(data);
      },
      onCardChangeResouse: data => {
        handleResouseChangeCard(data);
      },
      onModelChange: (data, type) => {
        handleSetPrice(data, type);
      },
      onModelOk: (data, closeCallback) => {
        handlerOrder(data, closeCallback, {
          domains
        });
      },
      onNormalNumChange: data => {
        handleCardNumChange(data);
      },
      onNormalBuyClick: (data, index) => {
        handlerCardOrder(data, index);
      },
      onFreeBuyClick: (data, index) => {
        handlerFreeBuyBtn(data, index);
      },
      onModelClose: () => {
        // 点击关闭，包括确定购买时，重置modelText中与镜像有关的参数
        setModelText(_objectSpread(_objectSpread({}, modelText), {}, {
          blueprintId: '',
          bluePrintList: '',
          isQueryPrice: false,
          isBuyWait: false
        }));
      },
      onCardChangeSdkAppId: data => {
        handleSdkAppChangeCard(data);
      }
    }));
  }
  return /*#__PURE__*/React.createElement("div", null);
}